<template>
  <Catalog
    title="Категория водительских прав"
    name-label="Категория"
    submit-error="Укажите категорию водительских прав."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :min-name-length="1"
    :exact-id="exactId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "DriverLicenseCategory",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    exactId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getDriverLicenseCategoryById(id);
    },
    async putData(data) {
      return await this.putDriverLicenseCategory(data)
    },
    async postData(data) {
      return await this.postDriverLicenseCategory(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/DriverLicenseCategories/DriverLicenseCategory.vue